// extracted by mini-css-extract-plugin
module.exports = {"usertab":"gonggelist_usertab_1b28p"};